import {
  REPORT_CLEAR_DATA,
  REPORT_LOAD_DATA,
  REPORT_LOAD_DATA_FAILURE,
  REPORT_LOAD_DATA_SUCCESS,
  REPORT_SORTING_CHANGE,
  REPORT_FILTERING_CHANGE,
  REPORT_MODE_CHANGE,
  CHANGE_ASYNC,
  SWITCH_TO_ASYNC_ENABLED_SUCCESS,
  CANCEL_REPORT_ENABLED_SUCCESS,
  SWITCH_TO_ASYNC_REPORT_SUCCESS,
} from '../actions/types/ReportActionTypes';
import { LOGGED_OUT } from '../../../../../core/modules/security/redux/actions/types/SecurityActionTypes';
import CarditCriticalElementsLocationReportMode
  from "../../../consignment/cardit-critical-elements/location/containers/CarditCriticalElementsLocationReportMode";
import Resdit7421PerformanceLocationReportMode
  from "../../../consignment/resdit-74-21-performance/location/containers/Resdit7421PerformanceLocationReportMode";
import CarditNestingCarrierReportMode
  from "../../../consignment/cardit-nesting/carrier/containers/CarditNestingCarrierReportMode";
import CarrierM39ComplianceLocationReportMode
  from "../../../carrier/m39-compliance/location/containers/CarrierM39ComplianceLocationReportMode";
import CarrierResdit7421PerformanceLocationReportMode
  from "../../../carrier/resdit-74-21-performance/location/containers/CarrierResdit7421PerformanceLocationReportMode";
import CarrierNestingLocationReportMode
  from "../../../carrier/nesting/location/containers/CarrierNestingLocationReportMode";

const reportInitialState = {
  isLoading: false,
  mainReportId: null,
  requestParams: {},
  metadata: {
    generatedOnDateTime: null,
  },
  isAsyncRequest: false,
  data: [],
  enabledAsyncSwitch: false,
  enabledCancelReport: false,
  openEmailModal: false,
};

const reportingInitialState = {
  DESPATCH_PARTICULARS_OVERVIEW: reportInitialState,
  DESPATCH_PARTICULARS_RECEPTACLE_TYPE: reportInitialState,
  DESPATCH_PARTICULARS_FORMAT_OF_CONTENTS: reportInitialState,
  DESPATCH_PARTICULARS_CONTENT: reportInitialState,
  DESPATCH_PARTICULARS_RECEPTACLE_DETAILS: reportInitialState,
  IMPC_TO_IMPC_DESPATCH_PERFORMANCE: reportInitialState,
  POST_TO_POST_DESPATCH_PERFORMANCE: reportInitialState,
  DESPATCH_MONITORING_OVERVIEW: reportInitialState,
  DESPATCH_MONITORING_RESPONSE_PERFORMANCE: reportInitialState,
  DESPATCH_MONITORING_RESPONSE_ANALYSIS: reportInitialState,
  DESPATCH_MONITORING_EVENT_TARGETS: reportInitialState,
  DESPATCH_MONITORING_RECEPTACLE_DETAILS: reportInitialState,
  DESPATCH_MEASUREMENTS_DAILY_EVOLUTION: reportInitialState,
  DESPATCH_MEASUREMENTS_HOURLY_EVOLUTION: reportInitialState,
  PREDES_RESDES_OPERATOR_MISMATCH: reportInitialState,
  MISMATCHED_SUBCLASS_RECEPTACLE_ID_VS_DESPATCH_ID: reportInitialState,
  PREDES_RESDES_MAILBOX_MISMATCH: reportInitialState,
  PREDES_AND_RESDES_INTERCHANGES: reportInitialState,
  PREDES_RESDES_DESPATCHES_SUMMARY: reportInitialState,
  PREDES_RESDES_DESPATCHES_DETAILS: reportInitialState,
  PREDES_DESTINATION_IMPC_CODE_NOT_REGISTERED_SUMMARY: reportInitialState,
  PREDES_DESTINATION_IMPC_CODE_NOT_REGISTERED_DETAILS: reportInitialState,
  RECEPTACLE_MONITORING_RESPONSE_PERFORMANCE: reportInitialState,
  RECEPTACLE_EVENT_IRREGULARITIES: reportInitialState,
  IPC_BAG_IS_PREDES_RESDES_ANALYSIS: reportInitialState,
  IPC_TRAY_IL_PREDES_RESDES_ANALYSIS: reportInitialState,
  IPC_PALLET_BOX_IB_PREDES_RESDES_ANALYSIS: reportInitialState,
  PREDES_ORIGIN_IMPC_CODE_NOT_REGISTERED_SUMMARY: reportInitialState,
  PREDES_ORIGIN_IMPC_CODE_NOT_REGISTERED_DETAILS: reportInitialState,
  ORIGIN_IMPC_OPERATOR_PREDES_SENDER_MISMATCH_SUMMARY: reportInitialState,
  ORIGIN_IMPC_OPERATOR_PREDES_SENDER_MISMATCH_DETAILS: reportInitialState,
  MULTIPLE_PREDES_SUMMARY: reportInitialState,
  MULTIPLE_PREDES_DETAILS: reportInitialState,
  RECEPTACLES_PREDES_RESDES_ANALYSIS: reportInitialState,
  RESCON_CONSIGNMENT_ID_NOT_IN_PRECON_SUMMARY: reportInitialState,
  RESCON_CONSIGNMENT_ID_NOT_IN_PRECON_DETAILS: reportInitialState,
  ITEMS_WITH_HANDOVER_DATA_AIR_SUMMARY: reportInitialState,
  ITEMS_WITH_HANDOVER_DATA_AIR_DETAILS: reportInitialState,
  PREDES_COMPLIANCE_INCORRECT_LOCATION_CODE_USAGE_SUMMARY: reportInitialState,
  PREDES_COMPLIANCE_INCORRECT_LOCATION_CODE_USAGE_DETAILS: reportInitialState,
  PREDES_COMPLIANCE_GAPS_IN_DESPATCH_NUMBERS: reportInitialState,
  ITEMS_WITH_HANDOVER_DATA_ROAD_SUMMARY: reportInitialState,
  ITEMS_WITH_HANDOVER_DATA_ROAD_DETAILS: reportInitialState,
  PREDES_IMPC_CODE_USAGE_NON_COMPLIANCE_SUMMARY: reportInitialState,
  PREDES_IMPC_CODE_USAGE_NON_COMPLIANCE_DETAILS: reportInitialState,
  PREDES_PLANNED_TRANSPORT_ANOMALIES_ORIGIN_SUMMARY: reportInitialState,
  PREDES_PLANNED_TRANSPORT_ANOMALIES_ORIGIN_DETAILS: reportInitialState,
  PREDES_PLANNED_TRANSPORT_ANOMALIES_DESTINATION_SUMMARY: reportInitialState,
  PREDES_PLANNED_TRANSPORT_ANOMALIES_DESTINATION_DETAILS: reportInitialState,
  TRACKED_ITEMS_IN_PREDES_SUMMARY: reportInitialState,
  TRACKED_ITEMS_IN_PREDES_DETAILS: reportInitialState,
  PREDES_TIMELINESS_SUMMARY: reportInitialState,
  PREDES_TIMELINESS_DETAILS: reportInitialState,
  PREDES_COMPLIANCE_MISSING_REQUIRED_ELEMENTS_SUMMARY: reportInitialState,
  PREDES_COMPLIANCE_MISSING_REQUIRED_ELEMENTS_DETAILS: reportInitialState,
  PREDES_COMPLIANCE: reportInitialState,
  RECEPTACLES_IN_PRECON_NOT_IN_PREDES_SUMMARY: reportInitialState,
  RECEPTACLES_IN_PRECON_NOT_IN_PREDES_DETAILS: reportInitialState,
  RECEPTACLES_IN_PREDES_NOT_IN_PRECON_SUMMARY: reportInitialState,
  RECEPTACLES_IN_PREDES_NOT_IN_PRECON_DETAILS: reportInitialState,
  PREDES_COMPLIANCE_MISSING_MANDATORY_ELEMENTS_ERROR_MESSAGES: reportInitialState,
  PREDES_COMPLIANCE_MISSING_MANDATORY_ELEMENTS_KEY_DETAILS: reportInitialState,
  PREDES_COMPLIANCE_MISSING_MANDATORY_ELEMENTS_SUMMARY: reportInitialState,
  PREDES_COMPLIANCE_MESSAGE_MAPPING_ERRORS_SUMMARY: reportInitialState,
  PREDES_COMPLIANCE_MESSAGE_MAPPING_ERRORS_MESSAGES: reportInitialState,
  PREDES_COMPLIANCE_MESSAGE_MAPPING_ERRORS_KEY_DETAILS: reportInitialState,
  RECEPTACLES_IN_PREDES_NOT_IN_CARDIT_SUMMARY: reportInitialState,
  RECEPTACLES_IN_PREDES_NOT_IN_CARDIT_DETAILS: reportInitialState,
  INTERCHANGE_DETAILS: reportInitialState,
  PRECON_RESCON_CONSIGNMENTS_SUMMARY: reportInitialState,
  PRECON_RESCON_CONSIGNMENTS_DETAILS: reportInitialState,
  INTERCHANGE_PROCESSING_SUMMARY: reportInitialState,
  INTERCHANGE_PROCESSING_DETAILS: reportInitialState,
  INTREF_SEQUENCE_VERIFICATION: reportInitialState,
  CARDIT_RESDIT_INTERCHANGES: reportInitialState,
  CONSIGNMENT_RESPONSE_ANALYSIS: reportInitialState,
  CONSIGNMENT_PARTICULARS: reportInitialState,
  CONSIGNMENT_RECEPTACLE_DETAILS: reportInitialState,
  MRD_XML_ANALYSIS: reportInitialState,
  HANDOVER_REGISTRATION_AT_ORIGIN: reportInitialState,
  OPERATIONAL_ANALYSIS: reportInitialState,
  OPERATIONAL_ANALYSIS_DAILY: reportInitialState,
  MRD_POD_OVERVIEW: reportInitialState,
  MRD_XML_DAILY_ANALYSIS: reportInitialState,
  CARDIT_NESTING_CARRIER: reportInitialState,
  CARDIT_NESTING_LOCATION: { ...reportInitialState, reportMode: CarditNestingCarrierReportMode.percentage },
  CARDIT_NESTING_DETAILS: reportInitialState,
  SAINT_PIERRE_ET_MIQUELON_SUMMARY: reportInitialState,
  SAINT_PIERRE_ET_MIQUELON_DETAILS: reportInitialState,
  CARDIT_RESDIT_BEST_PRACTICE_ELEMENTS_106: reportInitialState,
  RESDIT_74_21_PERFORMANCE_CARRIER_107B: reportInitialState,
  RESDIT_74_21_PERFORMANCE_LOCATION_107B: { ...reportInitialState, reportMode: Resdit7421PerformanceLocationReportMode.percentage },
  RESDIT_74_21_PERFORMANCE_DETAILS_107B: reportInitialState,
  CARDIT_CRITICAL_ELEMENTS_CARRIER: reportInitialState,
  CARDIT_CRITICAL_ELEMENTS_LOCATION: { ...reportInitialState, reportMode: CarditCriticalElementsLocationReportMode.percentage },
  CARDIT_CRITICAL_ELEMENTS_DETAILS: reportInitialState,
  RESDIT_74_21_PERFORMANCE_OPERATOR_802: reportInitialState,
  RESDIT_74_21_PERFORMANCE_LOCATION_802: { ...reportInitialState, reportMode: CarrierResdit7421PerformanceLocationReportMode.percentage },
  RESDIT_74_21_PERFORMANCE_DETAILS_802: reportInitialState,
  CARDIT_NESTING_OPERATOR_801: reportInitialState,
  CARDIT_NESTING_LOCATION_801: { ...reportInitialState, reportMode: CarrierNestingLocationReportMode.percentage },
  CARDIT_NESTING_DETAILS_801: reportInitialState,
  CARDIT_TIMELINESS_ANALYSIS: reportInitialState,
  CARDIT_CRITICAL_ELEMENTS_800_OPERATOR: reportInitialState,
  CARDIT_CRITICAL_ELEMENTS_800_LOCATION: { ...reportInitialState, reportMode: CarrierM39ComplianceLocationReportMode.percentage },
  CARDIT_CRITICAL_ELEMENTS_800_DETAILS: reportInitialState,
  CARRIER_MAIL_REGISTRATION_DEVICE_DELIVERY_SUMMARY: reportInitialState,
  CARRIER_MAIL_REGISTRATION_DEVICE_DELIVERY_CARRIER_PERFORMANCE: reportInitialState,
  CARRIER_MAIL_REGISTRATION_DEVICE_DELIVERY_DETAILS: reportInitialState,
  CARDIT_RESDIT_BEST_PRACTICE_ELEMENTS_804: reportInitialState,
  HANDLER_MAIL_REGISTRATION_DEVICE_DELIVERY_SUMMARY: reportInitialState,
  HANDLER_MAIL_REGISTRATION_DEVICE_DELIVERY_CARRIER_PERFORMANCE: reportInitialState,
  HANDLER_MAIL_REGISTRATION_DEVICE_DELIVERY_DETAILS: reportInitialState,
  CARDIT_BY_RECEIVING_AIRLINE: reportInitialState,
  CARDIT_BY_RECEIVING_AIRLINE_NUMBERED: reportInitialState,
  CARDIT_BY_SENDING_POST: reportInitialState,
  CARDIT_BY_SENDING_POST_NUMBERED: reportInitialState,
  RESDIT_BY_RECEIVING_POST: reportInitialState,
  RESDIT_BY_RECEIVING_POST_NUMBERED: reportInitialState,
  RESDIT_BY_SENDING_AIRLINE: reportInitialState,
  RESDIT_BY_SENDING_AIRLINE_NUMBERED: reportInitialState,
  TRANSPORT_EXCEPTIONS: reportInitialState,
  RECEPTACLE_TRANSPORT_OVERVIEW: reportInitialState,
  RECEPTACLE_OVERVIEW: reportInitialState,
  CARDIT_LINK_TRACE: reportInitialState,
  HANDLER_MONITORING: reportInitialState,
  CARRIER_ANALYSIS_411: reportInitialState,
  CARDIT_RESDIT_EVENT_OVERVIEW_105: reportInitialState,
  PAPER_FREE_MONITORING_POST_900_SUMMARY: reportInitialState,
  PAPER_FREE_MONITORING_POST_900_DETAILS: reportInitialState,
  RESDES_MANAGEMENT_SUMMARY_EPG: reportInitialState,
  PAPER_FREE_MONITORING_CARRIER_901_SUMMARY: reportInitialState,
  PAPER_FREE_MONITORING_CARRIER_901_DETAILS: reportInitialState,
  PAPER_FREE_MONITORING_CARRIER_903_SUMMARY: reportInitialState,
  PAPER_FREE_MONITORING_CARRIER_903_DETAILS: reportInitialState,
  PAPER_FREE_MONITORING_POST_902_SUMMARY: reportInitialState,
  PAPER_FREE_MONITORING_POST_902_DETAILS: reportInitialState,
  EPG_LINK_BY_LINK_REPORT_013: reportInitialState,
  HANDOVER_ANALYSIS_AT_DESTINATION: reportInitialState,
  MESSAGE_CAPABILITY_OVERVIEW: reportInitialState,
  MESSAGE_PROFILE: reportInitialState,
  EDI_EXCHANGE_LETTER_706: reportInitialState,
  EDI_EXCHANGE_PARCEL_706: reportInitialState,
  EDI_EXCHANGE_EMS_706: reportInitialState,
  TRAY_USAGE_940: reportInitialState,
  MIXED_TRAY_USAGE_942: reportInitialState,
  BAG_USAGE_950: reportInitialState,
  PALLET_BOX_USAGE_960: reportInitialState,
  COMPARATIVE_TRAY_USAGE_941: reportInitialState,
  COMPARATIVE_BAG_USAGE_951: reportInitialState,
  COMPARATIVE_PALLET_BOX_USAGE_961: reportInitialState,
  RECEPTACLE_POD_PERFORMANCE_404_SUMMARY: reportInitialState,
  RECEPTACLE_POD_PERFORMANCE_404_DETAILS: reportInitialState,
  CAPE_USAGE_MONITORING_1000: reportInitialState,
  CAPE_USAGE_MONITORING_BY_OPERATOR_1000: reportInitialState,
  CAPE_USAGE_MONITORING_BY_OPERATOR_USER_1000: reportInitialState,
  ITEM_OVERVIEW_V1_200: reportInitialState,
  ITEM_OVERVIEW_V2_201: reportInitialState,
  ITEM_OVERVIEW_DETAILS_200: reportInitialState,
  THRESHOLDS_FOR_CERTIFICATION_545_SUMMARY: reportInitialState,
  THRESHOLDS_FOR_CERTIFICATION_545_DETAILS: reportInitialState,
};

export default (state = reportingInitialState, action) => {
  switch (action.type) {
    case REPORT_LOAD_DATA:
      return {
        ...state,
        currentReportId: action.payload.reportDefinition.id,
        [action.payload.reportDefinition.id]: {
          ...reportingInitialState[action.payload.reportDefinition.id],
          isLoading: true,
        },
        enabledAsyncSwitch: false,
        enabledCancelReport: false,
      };
    case REPORT_LOAD_DATA_SUCCESS: {
      const {
        reportDefinition,
        mainReportId,
        requestParams,
        metadata,
        data,
      } = action.payload;
      return {
        ...state,
        currentReportId: reportDefinition.id,
        enabledCancelReport: true,
        [reportDefinition.id]: {
          ...reportingInitialState[reportDefinition.id],
          mainReportId,
          requestParams: { ...requestParams },
          metadata: { ...metadata },
          data: reportDefinition.dataTransformer([...data]),
        },
      };
    }
    case REPORT_LOAD_DATA_FAILURE:
      return {
        ...state,
        currentReportId: action.payload.reportDefinition.id,
        enabledCancelReport: true,
        [action.payload.reportDefinition.id]: {
          ...reportingInitialState[action.payload.reportDefinition.id],
          mainReportId: action.payload.mainReportId,
          error: action.payload.error,
        },
      };
    case REPORT_CLEAR_DATA:
      return action.payload.reportDefinition && action.payload.reportDefinition.id ? {
        ...state,
        currentReportId: action.payload.reportDefinition.id,
        [action.payload.reportDefinition.id]: reportingInitialState[action.payload.reportDefinition.id],
      } : reportingInitialState;
    case REPORT_MODE_CHANGE:
      return {
        ...state,
        [action.payload.reportDefinition.id]: {
          ...state[action.payload.reportDefinition.id],
          reportMode: action.payload.reportMode,
        },
      };
    case REPORT_SORTING_CHANGE:
      return {
        ...state,
        [action.payload.reportDefinition.id]: {
          ...state[action.payload.reportDefinition.id],
          sorting: action.payload.sorting,
        },
      };
    case REPORT_FILTERING_CHANGE:
      return {
        ...state,
        [action.payload.reportDefinition.id]: {
          ...state[action.payload.reportDefinition.id],
          filtering: action.payload.filtering,
        },
      };
    case CHANGE_ASYNC:
      return {
        ...state,
        [action.payload.reportDefinition.id]: {
          ...state[action.payload.reportDefinition.id],
          isAsyncRequest: action.payload.isAsyncRequest,
        },
      };
    case SWITCH_TO_ASYNC_ENABLED_SUCCESS:
      return {
        ...state,
        enabledAsyncSwitch: action.payload,
      };
    case CANCEL_REPORT_ENABLED_SUCCESS:
      return {
        ...state,
        enabledCancelReport: action.payload,
      };
    case SWITCH_TO_ASYNC_REPORT_SUCCESS:
      return {
        ...state,
        openEmailModal: true,
      };
    case LOGGED_OUT:
      return reportingInitialState;
    default:
      return state;
  }
};
